import { render } from "./DaumPostCode.vue?vue&type=template&id=535e5f76&scoped=true"
import script from "./DaumPostCode.vue?vue&type=script&lang=js"
export * from "./DaumPostCode.vue?vue&type=script&lang=js"

import "./DaumPostCode.vue?vue&type=style&index=0&id=535e5f76&scoped=true&lang=css"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535e5f76"]])

export default __exports__